<template>
    <v-layout row wrap>
        <v-flex>
            <v-text-field
                class="ucFirst body-2"
                :aria-label="formattedAriaLabel(
                    metadata[`description${this.upperLocale}`],
                    required
                )"
                :label="formattedLabel(
                    metadata[`description${this.upperLocale}`],
                    required
                )"
                :outlined="outlined"
                :append-icon="appendIcon"
                :value="value.trim()"
                :name="metadata.name"
                :color="$vuetify.theme.primary"
                :background-color="$vuetify.theme.primary"
                :placeholder="placeholder"
                maxlength="8"
                :rules="[
                    !required || requiredField('base.errors.requiredFieldConsentForm'),
                    v => !v || getFormRule('confirmationCode')(v)
                ]"
                :data-meta-id="metadata.id"
                :id="metadata.name"
                @input="debouncedInput"
            />
        </v-flex>
        <v-flex xs12 class="mb-4 px-4 body-1">
            <div class="mb-1" style="color: #cc0a00;" v-html="$t('form.consentHints.warning')" />
            <ul v-for="(text, index) in consentHints" class="consentHints" :key="index">
                <li v-html="text" />
            </ul>
            <div class="mt-1" v-html="$t('form.consentHints.thanks')" />
        </v-flex>
    </v-layout>
</template>

<script>
import { inputHelpers } from '@/mixins/inputHelpers';
import { mapGetters } from 'vuex';
import { formRules } from '@/mixins/form-rules';
import { debounce } from 'lodash';

export default {
    name: 'consent-form-confirmation-code',
    mixins: [formRules, inputHelpers],
    props: {
        metadata: { type: Object, required: true },
        outlined: { type: Boolean, required: false, default: true },
        required: { type: Boolean, required: false, default: false },
        value: { type: String, required: false, default: '' },
        withIcon: { type: Boolean, required: false, default: false },
        placeholder: { type: String, required: false, default: '' },
    },
    data() {
        return {
            debouncedInput: undefined,
        };
    },
    created() {
        this.debouncedInput = debounce(this.emitValue, 500);
    },
    computed: {
        ...mapGetters({
            locale: 'locale',
            upperLocale: 'upperLocale',
        }),

        appendIcon() {
            return this.withIcon ? 'fas fa-id-card-alt' : '';
        },
        consentHints() {
            return [
                this.$i18n.t('form.consentHints.bullet1'),
                this.$i18n.t('form.consentHints.bullet2'),
                this.$i18n.t('form.consentHints.bullet3'),
            ];
        },
    },
    methods: {
        emitValue(value) {
            this.$emit('update:value', value);
        },
    },
};
</script>

<style lang="scss">
    .consentHints{
        list-style: disc;
        margin-left: 15px;
    }

    a.consent-form-link:link,
    a.consent-form-link:visited,
    a.consent-form-link:hover,
    a.consent-form-link:active{
        color: #cc0a00;
    }
</style>
